import {
  VISUALIZATION_EXPORT_HEADER_CLASS_NAME,
  VISUALIZATION_LEGEND_CONTAINER_CLASS_NAME,
} from '@ardoq/global-consts';
import { ViewIds } from '@ardoq/api-types';

export const ONLY_EXPORT_CHILDREN_CLASS_NAME = 'exportChildren';
export const ONLY_EXPORT_CHILDREN_SELECTOR = `.${ONLY_EXPORT_CHILDREN_CLASS_NAME}`;
export const VIEW_LEGEND_SELECTOR = `.${VISUALIZATION_LEGEND_CONTAINER_CLASS_NAME}`;
export const VIEW_EXPORT_HEADER_SELECTOR = `.${VISUALIZATION_EXPORT_HEADER_CLASS_NAME}`;

/** whitespace around a direct canvas/SVG export, per side, in export pixels */
export const EXPORT_MARGIN_PX = 24;

export const HTML_EXPORT_LEGEND_PADDING = 16;
/** the whitespace around the HTML export, expressed as the total vertical or total horizontal padding, i.e. left _and_ right or top _and_ bottom combined. */
export const HTML_EXPORT_PADDING = 32;
export const DEVICE_PIXEL_RATIO = window.devicePixelRatio || 1;
export const PARTIALLY_RENDERED_VIEWS = new Set<ViewIds>([ViewIds.TIMELINE]);

/**
 * the maximum supported area for exporting.
 *
 * this is a soft limit and can be increased.
 *
 * the main concern here is probably the RAM consumed by the bitmap data. assuming 32bpp, that would be 4 * {@link CANVAS_MAXIMUM_AREA} bytes.
 */
export const CANVAS_MAXIMUM_AREA = 134000000;

/**
 * the maximum supported width or height for exporting.
 *
 * this is based on real browser limitations, but it might not be a hard limit.
 */
export const CANVAS_MAXIMUM_DIMENSION = 16384;
